export const getAvatarPosition = positionConfig => {
    return positionConfig.alyxPosition;
};

export const selectAvatarAudio = (_, alyxAudio) => alyxAudio;
